import axios from "axios";
import Cookies from "js-cookie";

function getCurrentAppPath() {
	const hash = window.location.hash || "";
	if (hash.startsWith("#")) {
		const pathFromHash = hash.slice(1);
		return pathFromHash && pathFromHash.startsWith("/")
			? pathFromHash
			: "/";
	}
	const path =
		(window.location.pathname || "/") + (window.location.search || "");
	return path.startsWith("/") ? path : "/";
}

const handleLogout = async () => {
	try {
		localStorage.setItem("lasturl", getCurrentAppPath());
		// const response = await axios.post(process.env.REACT_APP_API_URL+'/auth/logout',{
		//   data: {
		//       token: Cookies.get('mgltoken')
		//     },
		// });
		Cookies.set("mgltokenprevious", null, {
			expires: 7,
			domain: process.env.REACT_APP_DOMAIN,
		});
		Cookies.remove("mgltokenprevious", { path: "/" }); // Add path if needed
		Cookies.set("mgltoken", null, {
			expires: 7,
			domain: process.env.REACT_APP_DOMAIN,
		});
		Cookies.remove("mgltoken", { path: "/" }); // Add path if needed
		window.location.href =
			process.env.REACT_APP_FRONT_URL +
			"/#/login?app=" +
			process.env.REACT_APP_APP_KEY;
	} catch (error) {
		console.log(error);
	}
};

export default handleLogout;
